import Vuex, { StoreOptions, MutationTree, GetterTree, ActionTree } from 'vuex'
import Vue from 'vue'
import { campaignModule } from './modules/campaign'
import { themeModule } from './modules/theme'
import { pageModulesModule } from './modules/page-modules'
import { authModule } from './modules/auth'
import { journeyModule } from './modules/journey'

Vue.use(Vuex)

export interface RootState {
  isFooterOpen: boolean
}

export const rootState: RootState = {
  isFooterOpen: false,
}

export const rootMutations: MutationTree<RootState> = {
  SET_IS_FOOTER_OPPEN (state: RootState, isFooterOpen) {
    state.isFooterOpen = isFooterOpen
  },
}

export const rootGetters: GetterTree<RootState, any> = {
  isFooterOpen: (state: RootState) => state.isFooterOpen,
  storageKeyTab: (_, getters: any) => `${getters.campaignId}_community-app-tab`,
  storageKeyPage: (_, getters: any) => `${getters.campaignId}_community-app-page`,
}

export const rootActions: ActionTree<RootState, any> = {
}

export const storeOptions: StoreOptions<RootState> = {
  state: rootState,
  mutations: rootMutations,
  getters: rootGetters,
  actions: rootActions,
  modules: {
    campaign: campaignModule,
    theme: themeModule,
    pageModules: pageModulesModule,
    auth: authModule,
    journey: journeyModule
  },
}

export default new Vuex.Store(storeOptions)
